










































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import MonthCalendar, { SelectableDate } from '@/components/student/monthCalendar.vue';
import WeekCalendar from '@/components/student/weekCalendar.vue';
import DateCalendar from '@/components/student/dateCalendar.vue';
import BaseCalendar, { CalendarEvent } from '@/components/student/baseCalendar.vue';
import ReserveSelectCardList from '@/components/student/reserveSelectCardList.vue';
import {
  SchedulesRequest,
  Schedule,
  emptySchedule,
  ReservationRequest,
  StudentReservable
} from '@/modules/studentCalendar';
import { Tutor } from '@/modules/tutor';
import { Subject } from '@/models/subject';
import { Person } from '@/models/person';
import { School } from '@/modules/school';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';
import { UserTypes } from '@/enums/userTypes';
import moment from 'moment';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';
import { Dictionary } from 'vue-router/types/router';

enum ViewMode {
  View,
  Reserve,
  ReserveTime,
  ReserveConfirm,
}

enum CalendarMode {
  Month = '月',
  Week = '週',
  Date = '日',
}

@Component({
  components: {
    MonthCalendar, WeekCalendar, DateCalendar, ReserveSelectCardList,
  }
})
export default class extends AvaivaledVue {
  private ViewMode = ViewMode;

  private get pageTitle() { return '予約カレンダー'; }
  private get headerIcon() { return 'far fa-calendar-alt fa-2x'; }
  private get isLoading() {
    return (
      this.loading ||
      this.$store.state.studentCalendar.isLoading ||
      this.$store.state.student.loading
    );
  }
  private get studentId(): string { return this.$route.params.studentId; }
  private get student() { return this.$store.state.student.selectedStudent; }
  private get enableReserved() {
    if (!this.student) {
      return true;
    }
    const list: StudentReservable[] = this.$store.state.studentCalendar.studentReservableList;
    return !list.some((item) => item.reservableCount > 0);
  }
  private get isLarge(): boolean { return (this as any).$mq === 'large'; }
  private get isSmall(): boolean { return (this as any).$mq === 'small'; }
  private get isMini(): boolean { return (this as any).$mq === 'mini'; }
  private get buttonSize(): string { return this.isMini ? 'mini' : 'small'; }
  private get reservationRequest(): ReservationRequest {
    return this.$store.state.studentCalendar.reservationRequest;
  }
  private get reservationSchedules(): Schedule[] {
    return this.$store.state.studentCalendar.reservationSchedules;
  }
  private get reservationTutors(): Tutor[] {
    return this.$store.state.tutor.users.filter((tutor: Tutor) => {
      const findSubject = tutor.subjectList.find((subject: Subject) => {
        return subject.id === this.reservationRequest.subjectId;
      });
      return findSubject !== undefined;
    });
  }
  private get reservationDateSchedules(): Schedule[] {
    return this.reservationSchedules.filter((schedule: Schedule) => {
      const date = new Date(schedule.unixtimeDate * 1000);
      date.setHours(0); date.setMinutes(0); date.setSeconds(0);
      return date.getTime() === this.viewDate.getTime();
    });
  }
  private get sutudentReservableList() {
    const list: StudentReservable[] = this.$store.state.studentCalendar.studentReservableList;
    const reserveSelectedDateList = this.reserveSelectedList.reduce((countList, schedule) => {
      const targetDate = new Date(schedule.unixtimeDate * 1000);
      const date = new Date(
        targetDate.getFullYear(),
        targetDate.getMonth(),
        targetDate.getDate(),
      );
      const findItem = countList.find((item) => item.date === date);
      if (findItem) {
        findItem.count++;
      } else {
        countList.push({
          date,
          count: 1,
        });
      }
      return countList;
    }, new Array<{
      date: Date,
      count: number,
    }>());
    return list.map((item) => {
      const startMoment = moment(item.startDate);
      const endMoment = moment(item.endDate);

      let format = 'M月D日';
      if (startMoment.dayOfYear !== endMoment.dayOfYear) {
        format = 'YYYY年' + format;
      }

      const selectedCount = reserveSelectedDateList.reduce((count, selected) => {
        if (selected.date >= item.startDate && selected.date <= item.endDate) {
          count += selected.count;
        }
        return count;
      }, 0);

      return {
        isMonthCheck: item.isMonthCheck,
        startDate: startMoment.format(format),
        endDate: endMoment.format(format),
        reservableCount: item.reservableCount,
        selectCount: selectedCount,
      };
    });
  }

  private school: School = {
    schoolId: '',
    schoolName: '',
    ownerId: null,
    ownerName: '',
    note: '',
    paymentMailaddress: '',
    subjectList: [],
    tagList: [],
    availableFunctionbit: 0,
    availableFunctionTypes: [],
    reservableMonths: 0,
    cancellationDays: 0,
    ordinarySchoolList: [],
    isAutoEntryOrExit: false,
    collectionAgency: CollectionAgencyTypes.None,
  };

  private selectedDays: number[] = [];

  private get selectableDates(): SelectableDate[] {
    const studentReservableList: StudentReservable[] = this.$store.state.studentCalendar.studentReservableList;

    const dates: SelectableDate[] = [];
    this.reservationSchedules.forEach((schedule: Schedule) => {
      const date = new Date(schedule.unixtimeDate * 1000);
      date.setHours(0); date.setMinutes(0); date.setSeconds(0);
      const time = date.getTime();
      const findDate = dates.find((selectableDate: SelectableDate) => {
        return selectableDate.date.getTime() === time;
      });
      if (findDate === undefined) {

        let isSelectable = false;
        this.reservationSchedules.forEach((reservationSchedule: Schedule) => {
          const checkDate = new Date(reservationSchedule.unixtimeDate * 1000);
          checkDate.setHours(0); checkDate.setMinutes(0); checkDate.setSeconds(0);
          if (this.student && checkDate.getTime() === time) {
            // まだ予約できるかどうか
            if (reservationSchedule.reservers.length < reservationSchedule.capacity) {
              if (
                reservationSchedule.reservers.find((reserver: Person) => {
                  return reserver.id === this.student.id;
                }) === undefined
              ) {
                isSelectable = true;
              }
            }
          }
        });

        if (isSelectable) {
          // 予約可能コマ数でチェックする
          const target = studentReservableList.filter((studentReservable) => {
            return studentReservable.startDate <= date && studentReservable.endDate >= date;
          });
          if (target && target.length > 0) {
            // 該当日の予約可能コマ数がすべて予約可能かチェック
            isSelectable = target.every((studentReservable) => {
              return studentReservable.reservableCount > 0;
            });
          } else {
            //  予約可能コマ数の範囲外の場合、予約不可
            isSelectable = false;
          }
        }

        dates.push({
          date,
          isSelectable,
          isSelected: this.selectedDays.some((day) => date.getDate() === day),
        });
      }
    });
    return dates;
  }

  private get events(): CalendarEvent[] {
    const events: CalendarEvent[] = [];
    this.$store.state.studentCalendar.schedules.forEach((schedule: Schedule) => {
      const startDate = new Date(schedule.unixtimeDate * 1000);
      startDate.setHours(parseInt(schedule.stringStart.split(':')[0], 10));
      startDate.setMinutes(parseInt(schedule.stringStart.split(':')[1], 10));
      startDate.setSeconds(0);
      const endDate = new Date(schedule.unixtimeDate * 1000);
      endDate.setHours(parseInt(schedule.stringEnd.split(':')[0], 10));
      endDate.setMinutes(parseInt(schedule.stringEnd.split(':')[1], 10));
      endDate.setSeconds(0);
      events.push({
        eventId: schedule.scheduleId.toString(),
        startDate,
        endDate,
        color: schedule.subject.color !== null ? schedule.subject.color : '',
        monthHtml: this.makeMonthHtml(schedule),
        weekShortHtml: this.makeWeekShortHtml(schedule),
        weekLongHtml: this.makeWeekLongHtml(schedule),
        dateShortHtml: this.makeDateShortHtml(schedule),
        dateLongHtml: this.makeDateLongHtml(schedule),
      });
    });
    return events;
  }

  private get request(): SchedulesRequest { return this.$store.state.studentCalendar.schedulesRequest; }
  private set request(request: SchedulesRequest) {
    this.$store.commit('studentCalendar/setSchedulesRequest', request);
  }
  private get isMonthCalendar(): boolean { return this.calendarMode === CalendarMode.Month; }
  private get isWeekCalendar(): boolean { return this.calendarMode === CalendarMode.Week; }
  private get isDateCalendar(): boolean { return this.calendarMode === CalendarMode.Date; }
  private get isReservationCalendar(): boolean { return this.viewMode === ViewMode.Reserve; }
  private get month(): number { return this.viewDate.getMonth(); }
  private readonly WEEK_NAMES = ['日', '月', '火', '水', '木', '金', '土'];

  private isOpenDetailModal = false;
  private detailSchedule: Schedule = emptySchedule();

  private isOpenReservationModal = false;
  private loading = false;
  private CalendarMode = CalendarMode;
  private HEADER_WEEKS = [ 1, 2, 3, 4, 5, 6, 0 ]; // 曜日の数値 0 ~ 6

  private viewMode: ViewMode = ViewMode.View;
  private calendarMode: CalendarMode = CalendarMode.Month;
  private weekCalendar: any;

  private viewDate: Date = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate(),
    0, 0, 0);

  private cancellationNowDate: Date = new Date();

  private get cancellationDay(): number {
    return this.school.cancellationDays;
  }

  private get enableCancel(): boolean {
    // 学生アカウントではない場合は常にキャンセル許可
    if (this.userRole !== UserTypes.Student) {
      return true;
    }
    const checkDate = new Date(this.detailSchedule.unixtimeDate * 1000);
    checkDate.setDate(checkDate.getDate() - this.cancellationDay);
    return checkDate.getTime() >= this.cancellationNowDate.getTime();
  }

  private get reservableList() {
    return this.reservationSchedules.filter((schedule: Schedule) => {
      const date = new Date(schedule.unixtimeDate * 1000);
      return this.selectedDays.some((day) => date.getDate() === day);
    });
  }

  private reserveSelectedIdList: number[] = [];

  private get reserveSelectedList() {
    return this.reservationSchedules.filter((item) => this.reserveSelectedIdList.some((id) => id === item.scheduleId));
  }

  @Watch('reservationRequest.subjectId')
  private onChangedReservationRequestSubjectId() {
    this.reservationRequest.tutorId = '';
  }
  private weekCalendarFormat(): string {
    if (!this.weekCalendar) { return ''; }
    const firstDate = this.weekCalendar.firstDate();
    const lastDate = this.weekCalendar.lastDate();
    if (firstDate === null || lastDate === null) { return ''; }

    return (
      firstDate.getFullYear() + '年' + (firstDate.getMonth() + 1) + '月' + firstDate.getDate() + '日～' +
      (lastDate.getMonth() + 1) + '月' + lastDate.getDate() + '日'
    );
  }

  private scrollTop() {
    const page = this.$el.getElementsByClassName('page-content-main')[0];
    page.scrollTop = 0;
  }

  private async loadData() {
    this.school = await this.$store.dispatch('adminSchool/getSchool', this.$store.getters['auth/schoolId']);
    this.$store.dispatch('student/selectStudent', this.studentId);
    this.request.studentId = this.studentId;
    this.$store.dispatch('studentCalendar/getSchedulesRequest');
    this.$store.dispatch('studentCalendar/getStudentReservableList');
    this.$store.dispatch('tutor/searchTutors', {
      authoriry: 2,
      keyWord: '',
      perPage: 10000,
      page: 1,
      sort: '',
    });
  }

  @Watch('$route.query.mode')
  private async onChangeReserveMode() {
    await this.reloadView();
  }

  private async mounted() {
    await this.reloadView();
  }

  private deactivated() {
    this.$destroy();
  }

  private created() {
    this.pageBackCheck(FunctionTypes.Reserve);
  }

  private async reloadView() {
    this.weekCalendar = this.$refs.week;

    this.reservationRequest.studentId = this.studentId;

    const query: Dictionary<string> = Object.keys(this.$route.query).reduce((list, key) => {
      const lowerKey = key.toLowerCase();
      Object.defineProperty(list, lowerKey, { value: this.$route.query[key] });
      return list;
    }, {});

    if (query.year && query.month) {
      this.reservationRequest.year = parseInt(query.year, 10);
      this.reservationRequest.month = parseInt(query.month, 10);
    } else {
      this.reservationRequest.year = new Date().getFullYear();
      this.reservationRequest.month = new Date().getMonth() + 1;
    }

    let newDate = new Date(
      this.reservationRequest.year,
      this.reservationRequest.month - 1,
      new Date().getDate(),
      0, 0, 0);

    if (newDate.getMonth() > this.reservationRequest.month - 1) {
      newDate = new Date(
        newDate.getFullYear(),
        newDate.getMonth(),
        1,
        0, 0, 0);
      newDate.setDate(newDate.getDate() - 1);
    }

    this.viewDate = newDate;

    this.onChangedMonth();

    switch (query.mode) {
      case 'reserve':
        this.viewMode = ViewMode.Reserve;
        break;
      case 'reserve-times':
        this.viewMode = ViewMode.ReserveTime;
        break;
      case 'reserve-confirm':
        this.viewMode = ViewMode.ReserveConfirm;
        break;
      default:
        this.viewMode = ViewMode.View;
        break;
    }

    switch (this.viewMode) {
      case ViewMode.Reserve:
      case ViewMode.ReserveTime:
      case ViewMode.ReserveConfirm:
        this.selectedDays = query.days?.split(',').map((item) => parseInt(item.trim(), 10)) ?? [];
        this.reservationRequest.tutorId = query.tutor;
        this.reservationRequest.subjectId = parseInt(query.subject, 10);
        await this.changeReservation();

        if (!this.isReservationState) {
          this.$router.replace({
            path: this.$route.path,
            query: {
              year: this.viewDate.getFullYear().toString(),
              month: (this.viewDate.getMonth() + 1).toString(),
            }
          });
          return;
        }

        switch (this.viewMode) {
          case ViewMode.ReserveTime:
          case ViewMode.ReserveConfirm:
            this.reserveSelectedIdList = query.select?.split(',').map((item) => parseInt(item.trim(), 10)) ?? [];
        }
        break;
      default:
        await this.reservationCancel();

        if (query.calendar) {
          switch (query.calendar.trim()) {
            case 'week':
              this.calendarMode = CalendarMode.Week;
              break;
            case 'day':
              this.calendarMode = CalendarMode.Date;
              break;
            default:
              this.calendarMode = CalendarMode.Month;
              break;
          }
          switch (this.calendarMode) {
            case CalendarMode.Week:
            case CalendarMode.Date:
              this.viewDate = new Date(
                  this.reservationRequest.year,
                  this.reservationRequest.month - 1,
                  parseInt(query.day, 10) ?? new Date().getDate(),
                  0, 0, 0);
              break;
          }
        } else {
          this.calendarMode = CalendarMode.Month;
        }
        break;
    }
  }

  private updateViewDate(addMonth: number, addDate: number) {
    let newDate = new Date(
      this.viewDate.getFullYear(),
      this.viewDate.getMonth() + addMonth,
      this.viewDate.getDate() + addDate,
      0, 0, 0);

    if (addMonth > 0
      && newDate.getMonth() > this.viewDate.getMonth() + addMonth
      && newDate.getFullYear() === this.viewDate.getFullYear()) {
      newDate = new Date(
        newDate.getFullYear(),
        newDate.getMonth(),
        1,
        0, 0, 0);
      newDate.setDate(newDate.getDate() - 1);
    }

    this.viewDate = newDate;
    this.onChangedViewDate();
  }

  private clickRightArrow() {
    switch (this.calendarMode) {
      case CalendarMode.Month: this.updateViewDate(1, 0); break;
      case CalendarMode.Week:  this.updateViewDate(0, 7); break;
      case CalendarMode.Date:  this.updateViewDate(0, 1); break;
    }
  }

  private clickLeftArrow() {
    switch (this.calendarMode) {
      case CalendarMode.Month: this.updateViewDate(-1, 0); break;
      case CalendarMode.Week:  this.updateViewDate(0, -7); break;
      case CalendarMode.Date:  this.updateViewDate(0, -1); break;
    }
  }

  @Watch('month')
  private onChangedMonth() {
    this.request = {
      studentId: this.studentId,
      year: this.viewDate.getFullYear(),
      month: this.viewDate.getMonth() + 1,
    };
    this.loadData();
  }

  private onChangedViewDate() {
    const query = this.isMonthCalendar
      ? {
        year: this.viewDate.getFullYear().toString(),
        month: (this.viewDate.getMonth() + 1).toString(),
      }
      : {
        calendar: this.isWeekCalendar ? 'week' : 'day',
        year: this.viewDate.getFullYear().toString(),
        month: (this.viewDate.getMonth() + 1).toString(),
        day: this.viewDate.getDate().toString(),
      };
    this.$router.replace({
      path: this.$route.path,
      query: query as any,
    });
  }

  @Watch('calendarMode')
  private onChangedMode() {
    this.loading = true;
    if (this.calendarMode === CalendarMode.Week) {
      this.$nextTick(() => {
        this.weekCalendar = this.$refs.week;
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  }

  private reservation() {
    this.isOpenReservationModal = true;
    this.reservationRequest.studentId = this.studentId;
    this.reservationRequest.year = this.viewDate.getFullYear();
    this.reservationRequest.month = this.viewDate.getMonth() + 1;
    this.reservationRequest.subjectId = this.student.subjectList.length === 0 ? '' : this.student.subjectList[0].id;
    this.reservationRequest.tutorId = '';
  }

  private async clickReservationCancel() {
    await this.reservationCancel();

    this.$router.push({
      path: this.$route.path,
      query: {
        year: this.viewDate.getFullYear().toString(),
        month: (this.viewDate.getMonth() + 1).toString(),
      }
    });
  }

  private async reservationCancel() {
    this.$store.commit('studentCalendar/setReservationSchedules', []);
    this.selectedDays = [];
    this.calendarMode = CalendarMode.Month;
  }

  private async clickReservation() {
    await this.changeReservation();

    if (!this.isReservationState) {
      this.$alert('予約可能なコマが見つかりません', '', {
        type: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    this.$router.push({
      path: this.$route.path,
      query: {
        mode: 'reserve',
        year: this.viewDate.getFullYear().toString(),
        month: (this.viewDate.getMonth() + 1).toString(),
        tutor: this.reservationRequest.tutorId,
        subject: this.reservationRequest.subjectId.toString(),
      }
    });
  }

  private async changeReservation() {
    this.calendarMode = CalendarMode.Month;
    await this.$store.dispatch('studentCalendar/getReservationSchedules');
    this.isOpenReservationModal = false;
  }

  private get isReservationState(): boolean {
    return this.reservationSchedules.length > 0;
  }

  @Watch('isMini')
  private onChangedIsMini() {
    if (this.isMini && this.isWeekCalendar) {
      this.calendarMode = CalendarMode.Date;
    }
  }

  private clickMonthCalendarCell(date: Date) {
    this.calendarMode = CalendarMode.Date;
    this.viewDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  private clickMonthCalendarSelectableCell(date: Date) {
    this.selectedDays = this.selectableDates.filter((item) => item.isSelected)
      .map((item) => item.date.getDate())
      .sort((a, b) => {
        if (a < b) { return -1; }
        if (a > b) { return 1; }
        return 0;
      });
    this.$router.replace({
      path: this.$route.path,
      query: {
        mode: 'reserve',
        year: this.viewDate.getFullYear().toString(),
        month: (this.viewDate.getMonth() + 1).toString(),
        tutor: this.reservationRequest.tutorId,
        subject: this.reservationRequest.subjectId.toString(),
        days: this.selectedDays.join(','),
      }
    });
  }

  private clickReserveSelectCard(scheduleIds: number[]) {
    const targetScheduleIds = scheduleIds.sort().join(',');
    const query = {
      ...this.$route.query,
      mode: 'reserve-times',
      select: targetScheduleIds,
    };
    if (targetScheduleIds.length === 0) {
      delete (query as any).select;
    }
    this.$router.replace({
      path: this.$route.path,
      query
    });
  }

  private clickWeekTag(date: Date) {
    this.calendarMode = CalendarMode.Date;
    this.viewDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  private clickDateTag(eventId: string) {
    this.detailSchedule = this.$store.state.studentCalendar.schedules.find((schedule: Schedule) => {
      return parseInt(eventId, 10) === schedule.scheduleId;
    });
    if (this.detailSchedule !== undefined) {
      this.$nextTick(() => {
        this.cancellationNowDate = new Date();
        this.isOpenDetailModal = true;
      });
    }
  }

  private makeMonthHtml(schedule: Schedule): string {
    if (!this.isLarge) { return schedule.subject.name; }
    return `
<ul style="text-align: left; list-style: none; padding: 5px; margin: 0;">
  <li>${schedule.stringStart} ～ <span style="display: inline-block">${schedule.stringEnd}</span></li>
  <li>${schedule.subject.name}</li>
  <li>${schedule.tutorName}</li>
  <li>
    <span style="display: inline-block">
      ${this.makeCapacity(schedule)}
    </span>
  </li>
</ul>`;
  }

  private makeWeekShortHtml(schedule: Schedule): string {
    return `
<ul style="text-align: left; list-style: none; margin: 0; padding: 0 0 0 10px;">
  <li>${schedule.stringStart} ～ ${schedule.subject.name}</li>
</ul>`;
  }

  private makeWeekLongHtml(schedule: Schedule): string {
    return `
<ul style="text-align: left; list-style: none; margin: 0; padding: 0 0 0 10px;">
  <li>${schedule.stringStart} ～ <span style="display: inline-block">${schedule.stringEnd}</span></li>
  <li>${schedule.subject.name}</li>
</ul>`;
  }

  private makeDateShortHtml(schedule: Schedule): string {
    return `
<ul style="text-align: left; list-style: none; margin: 0; padding: 0 0 0 10px;">
  <li>
    <span style="display: inline-block; background-color: white; border: solid 1px red; padding: 0; margin: 0;">
      <span
        style="display: inline-block; color: red; background-color: rgba(245,108,108,0.2);
        margin: 0; padding: 2px 5px; font-size: 10px;"
      >
        予約済
      </span>
    </span>
  　${schedule.stringStart} ～　${schedule.subject.name}　${schedule.tutorName}
  </li>
</ul>`;
  }

  private makeDateLongHtml(schedule: Schedule): string {
    return `
<ul style="text-align: left; list-style: none; margin: 0; padding: 0 0 0 10px;">
  <li>
    <span style="display: inline-block; background-color: white; border: solid 1px red; padding: 0; margin: 0;">
      <span
        style="display: inline-block; color: red; background-color: rgba(245,108,108,0.2);
        margin: 0; padding: 2px 5px; font-size: 10px;"
      >
        予約済
      </span>
    </span>
  　${schedule.stringStart} ～ <span style="display: inline-block">${schedule.stringEnd}</span>
  </li>
  <li>
    ${schedule.subject.name}　${schedule.tutorName}　<span style="display: inline-block">
    ${this.makeCapacity(schedule)}
  </li>
</ul>`;
  }

  private makeCapacity(schedule: Schedule) {
    const num = schedule.capacity - schedule.reservers.length;
    return `残${ num < 0 ? 0 : num } / 定員${ schedule.capacity }人`;
  }

  private isAlreadyReserved(schedule: Schedule) {
    const findReserver = schedule.reservers.find((reserver: Person) => {
      return reserver.id === this.student.id;
    });
    return findReserver !== undefined;
  }

  private isNotReservable(schedule: Schedule) {
    if (schedule.reservers.length >= schedule.capacity) {
      return true;
    }
    const date = new Date(schedule.unixtimeDate * 1000);
    date.setHours(0); date.setMinutes(0); date.setSeconds(0);
    // 予約可能コマ数でチェックする
    const studentReservableList: StudentReservable[] = this.$store.state.studentCalendar.studentReservableList;
    const target = studentReservableList.filter((studentReservable) => {
      return studentReservable.startDate <= date && studentReservable.endDate >= date;
    });
    if (target && target.length > 0) {
      // 該当日の予約可能コマ数がすべて予約可能かチェック
      return !target.every((studentReservable) => {
        return studentReservable.reservableCount > 0;
      });
    } else {
      //  予約可能コマ数の範囲外の場合、予約不可
      return true;
    }
  }

  private makeReservationText(schedule: Schedule) {
    if (this.isAlreadyReserved(schedule)) {
      return (
`<span style="display: inline-block; background-color: white; border: solid 1px red; padding: 0; margin: 0;">
  <span
    style="display: inline-block; color: red; background-color: rgba(245,108,108,0.2);
    margin: 0; padding: 2px 5px; font-size: 10px;"
  >
    予約済
  </span>
</span>`);
    }

    if (this.isNotReservable(schedule)) {
      return '予約不可';
    }

    return '予約可';
  }

  private clickReservationTag(schedule: Schedule) {
    if (this.isAlreadyReserved(schedule)) {
      return;
    }

    if (this.isNotReservable(schedule)) {
      return;
    }
    this.detailSchedule = schedule;
    this.cancellationNowDate = new Date();
    this.isOpenDetailModal = true;
  }

  private sendReservation() {
    this.$confirm('予約内容を送信します。よろしいですか？', '', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    }).then(async () => {
      const request = {
        scheduleId: this.detailSchedule.scheduleId,
        calendarId: this.detailSchedule.calendarId,
        studentId: this.studentId,
        subjectId: this.detailSchedule.subject.id,
        isForce: false,
      };

      try {
        await this.$store.dispatch('studentCalendar/sendReservation', request);
        this.clickReservationCancel();
        this.loadData();
        this.isOpenDetailModal = false;

        this.$notify({
          type: 'success',
          title: '予約完了',
          message:
            `予約内容の登録を行いました。`,
          position: 'bottom-right'
        });
      } catch (error) {
        this.isOpenDetailModal = false;
        this.$notify({
          type: 'error',
          title: '予約失敗',
          message:
            error.response.data,
          position: 'bottom-right'
        });
      }

    }).catch(() => {
      const a = 1;
    });
  }

  private cancel() {
    this.$confirm('予約内容をキャンセルします。よろしいですか？', '', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    }).then(async () => {
      const response = await this.$store.dispatch('studentCalendar/cancelReservation', {
        studentId: this.studentId,
        scheduleId: this.detailSchedule.scheduleId,
      });
      if (response && response.status === 201) {
        this.clickReservationCancel();
        this.loadData();
        this.isOpenDetailModal = false;

        this.$notify({
          type: 'success',
          title: '予約キャンセル完了',
          message:
            `予約内容のキャンセルを行いました。`,
          position: 'bottom-right'
        });
        this.loadData();
      } else {
        this.$notify({
          type: 'error',
          title: '予約キャンセル失敗',
          message:
            response.message,
          position: 'bottom-right'
        });
      }

    }).catch(() => {
      const a = 1;
    });
  }

  private selectReservationTimes() {
    const targetDays = this.selectableDates.filter((item) => item.isSelected)
      .map((item) => item.date.getDate())
      .sort((a, b) => {
        if (a < b) { return -1; }
        if (a > b) { return 1; }
        return 0;
      })
      .join(',');
    this.$router.push({
      path: this.$route.path,
      query: {
        mode: 'reserve-times',
        year: this.viewDate.getFullYear().toString(),
        month: (this.viewDate.getMonth() + 1).toString(),
        tutor: this.reservationRequest.tutorId,
        subject: this.reservationRequest.subjectId.toString(),
        days: targetDays,
      }
    });

    this.$nextTick(() => {
      this.scrollTop();
    });
  }

  private confirmReservationTimes() {
    this.$router.push({
      path: this.$route.path,
      query: {
        ...this.$route.query,
        mode: 'reserve-confirm',
      }
    });

    this.$nextTick(() => {
      this.scrollTop();
    });
  }

  private bulkReserve() {
    this.$confirm('予約内容を送信します。よろしいですか？', '', {
      confirmButtonText: 'はい',
      cancelButtonText: 'いいえ',
      type: 'warning'
    }).then(async () => {
      const request = this.reserveSelectedList.map((schedule) => ({
        scheduleId: schedule.scheduleId,
        calendarId: schedule.calendarId,
        studentId: this.studentId,
        subjectId: schedule.subject.id,
        isForce: false,
      }));

      try {
        await this.$store.dispatch('studentCalendar/sendBulkReservation', request);
        this.clickReservationCancel();
        this.loadData();
        this.isOpenDetailModal = false;

        this.$notify({
          type: 'success',
          title: '予約完了',
          message:
            `予約を行いました。`,
          position: 'bottom-right'
        });
      } catch (error) {
        this.isOpenDetailModal = false;
        this.$notify({
          type: 'error',
          title: '予約失敗',
          message:
            error.response.data,
          position: 'bottom-right'
        });
      }

    }).catch(() => {
      const a = 1;
    });
  }
}
